import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=140d72cb&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=140d72cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140d72cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/app/site2/src/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('140d72cb')) {
      api.createRecord('140d72cb', component.options)
    } else {
      api.reload('140d72cb', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=140d72cb&scoped=true&", function () {
      api.rerender('140d72cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Portefeuille/Sidebar.vue"
export default component.exports